exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gallery-edit {\n  display: block;\n  margin-bottom: 20px;\n}\ngallery-edit .icon-19 {\n  font-size: 19px;\n  height: 19px;\n  width: 19px;\n  line-height: 19px;\n  min-width: 19px;\n  min-height: 19px;\n  user-select: none;\n}\ngallery-edit .width-50 {\n  width: 50px;\n}\ngallery-edit {\n  /* Loader */\n}\ngallery-edit .fitit-loader {\n  height: calc(100vh - 500px);\n}\ngallery-edit .fitit-loader md-progress-circular svg path {\n  stroke: #09aa89;\n}", ""]);

// exports
